module.exports = __webpack_public_path__ + "assets/lotterying-btn-en-2046a420.svga";